import ImageOptimizer from '@/components/image-optimizer';
import { unlimitedCurriculumSteps } from '@/data/recommend-class/unlimited.data';
import CurriculumStepCarousel from '../../components/curriculum-step-carousel';

interface UnlimitedCurriculumProps {
  id: string;
}

export default function UnlimitedCurriculum({ id }: UnlimitedCurriculumProps) {
  return (
    <div
      id={id}
      className="desktop:pb-[128px] flex flex-col items-center justify-center bg-[#272A32]"
      style={{
        backgroundImage: `url('/images/recommend-class/common/curriculum_bg.svg')`,
        backgroundSize: '2px 72px',
        backgroundPosition: 'center',
        backgroundRepeat: 'repeat',
      }}
    >
      <div
        className="relative h-[41px] w-full overflow-hidden"
        style={{
          backgroundImage: `url('/images/recommend-class/unlimited/subtract_bg.svg')`,
          backgroundSize: 'auto',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>
      {/**웹 */}
      <div className="desktop:block desktop:mt-[128px] relative hidden">
        <ImageOptimizer
          src="/images/recommend-class/unlimited/curriculum_comment.svg"
          alt="curriculum top"
          width={311}
          height={86}
          className="object-contain"
        />
      </div>
      <div className="desktop:block typo-40 desktop:mb-8 desktop:mt-[32px] mt-4 mb-5 hidden font-semibold text-white">
        <span className="text-main-yellow font-extrabold">
          체계적인 커리큘럼
        </span>
        으로 운전마스터 해보세요!
      </div>
      <div className="desktop:flex desktop:typo-28 typo-18 hidden flex-col items-center justify-center gap-4 font-semibold text-[#ECECEC]">
        <span>3D로 구현된 전국의 모든 운전면허시험장 코스를</span>
        <span>
          반복 주행 연습함으로서 가장 안전하고 빠른 면허 취득을 제안합니다.
        </span>
      </div>

      {/**모바일 */}
      <div className="desktop:hidden relative mt-[90px]">
        <ImageOptimizer
          src="/images/recommend-class/unlimited/curriculum_comment_mo.svg"
          alt="curriculum top"
          width={185}
          height={54}
          className="object-contain"
        />
      </div>
      <div className="desktop:hidden typo-28 mt-4 mb-5 text-center leading-snug font-semibold text-white">
        <span className="text-main-yellow font-extrabold">
          체계적인 커리큘럼
        </span>
        으로 <br />
        운전마스터 해보세요!
      </div>
      <div className="desktop:hidden typo-18 flex flex-col items-center justify-center gap-2 font-semibold text-[#ECECEC]">
        <span>3D로 구현된 전국의 모든 운전면허시험장</span>
        <span>코스를 반복 주행 연습함으로서 가장 안전하고</span>
        <span>빠른 면허 취득을 제안합니다.</span>
      </div>

      <CurriculumStepCarousel steps={unlimitedCurriculumSteps} />
    </div>
  );
}
